import React from "react";
import { useUser } from "../context/UserContext";
import { can } from "./access";

export default function Can({ permission, children, fallback = null, mode = "hide" }) {
  const { localUser } = useUser();
  const allowed = can(localUser, permission);

  if (allowed) return children;

  const message = fallback || (
    <div className="text-center text-muted mb-2">
      Sinulla ei ole oikeuksia nähdä tätä sisältöä.
    </div>
  );

  if (mode === "disable") {
    // Only show the message, don't render children at all
    return message;
  }

  // hide mode: don't render anything
  return null;
}
